import { BMPrimitives, BMText } from "@traveloka/district-bloom";
import IcSystemCrossClose from "@traveloka/icon-kit-web/react/IcSystemCrossClose";
import { Image, Pressable, StyleSheet } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { ILLUSTRATION_SWITCH_DESKTOP } from "../../../assets/illustration-switch-desktop";
import { FullScreenDialog } from "../../../components";
import BMView from "../../../components/View/BMView";

type Props = {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export default function ConfirmSwitchDesktop({
  show,
  onClose,
  onConfirm,
}: Props) {
  const insets = useSafeAreaInsets();

  return (
    <FullScreenDialog visible={show} noAnimation zIndex={99}>
      <BMView style={{ paddingTop: insets.top }} flex>
        <BMView align="end">
          <Pressable onPress={onClose}>
            <BMView style={styles.closeButton}>
              <IcSystemCrossClose width={24} height={24} />
            </BMView>
          </Pressable>
        </BMView>
        <BMView flex justify="center">
          <BMView spacing="lg" style={styles.positionsBottomXL6}>
            <BMView style={styles.imageWrapper} align="center">
              <Image
                style={styles.image}
                source={{ uri: ILLUSTRATION_SWITCH_DESKTOP }}
              />
            </BMView>
            <BMView align="center" spacing="sm">
              <BMText variant="titleSmall">
                This page is only available on desktop
              </BMText>
              <BMText variant="paragraphNormal">
                Please switch to the desktop version to continue.
              </BMText>
            </BMView>
            <BMView align="center">
              <Pressable onPress={onConfirm}>
                <BMText variant="uiLarge" ink="BMStyleTextInkAction">
                  Switch to desktop
                </BMText>
              </Pressable>
            </BMView>
          </BMView>
        </BMView>
      </BMView>
    </FullScreenDialog>
  );
}

const styles = StyleSheet.create({
  closeButton: {
    padding: BMPrimitives.BMSize.md,
  },
  imageWrapper: {
    padding: BMPrimitives.BMSize.xl2,
  },
  positionsBottomXL6: {
    bottom: BMPrimitives.BMSize.xl6,
  },
  image: {
    width: 120,
    height: 120,
  },
});
